
import { Check } from "lucide-react";

interface TimelineStepProps {
  title: string;
  icon: React.ReactNode;
  isActive: boolean;
  isCompleted: boolean;
}

export function TimelineStep({ title, icon, isActive, isCompleted }: TimelineStepProps) {
  return (
    <div className="flex flex-col items-center flex-1">
      <div
        className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 transition-colors ${
          isCompleted
            ? "bg-drcash-caribbean-green text-white"
            : isActive
            ? "bg-drcash-sapphire-blue text-white"
            : "bg-gray-200 text-gray-400"
        }`}
      >
        {isCompleted ? <Check className="w-5 h-5" /> : icon}
      </div>
      <span
        className={`text-sm text-center ${
          isActive ? "text-drcash-sapphire-blue font-medium" : "text-gray-500"
        }`}
      >
        {title}
      </span>
    </div>
  );
}
